"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selected = exports.Deselected = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../colors");
/* eslint-disable react/jsx-curly-brace-presence */


var Deselected =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Deselected, _PureComponent);

  function Deselected() {
    (0, _classCallCheck2["default"])(this, Deselected);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Deselected).apply(this, arguments));
  }

  (0, _createClass2["default"])(Deselected, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          color = _this$props.color,
          backgroundColor = _this$props.backgroundColor;
      return _react["default"].createElement("svg", {
        width: width,
        height: width,
        viewBox: "0 0 24 24"
      }, _react["default"].createElement("defs", null, _react["default"].createElement("path", {
        id: "radio-default-a",
        d: "M12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,\n            2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,12 C2.18181818,17.4224321 6.57756791,21.8181818 12,\n            21.8181818 Z M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z"
      })), _react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        stroke: "black",
        strokeWidth: "0",
        fill: backgroundColor
      }), _react["default"].createElement("use", {
        fill: color,
        xlinkHref: "#radio-default-a"
      })));
    }
  }]);
  return Deselected;
}(_react.PureComponent);

exports.Deselected = Deselected;
Deselected.propTypes = {
  width: _propTypes["default"].string,
  color: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string
};
Deselected.defaultProps = {
  width: '16px',
  color: _colors.cobalt.base,
  backgroundColor: 'none'
};

var Selected =
/*#__PURE__*/
function (_PureComponent2) {
  (0, _inherits2["default"])(Selected, _PureComponent2);

  function Selected() {
    (0, _classCallCheck2["default"])(this, Selected);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Selected).apply(this, arguments));
  }

  (0, _createClass2["default"])(Selected, [{
    key: "render",
    // eslint-disable-line react/no-multi-comp
    value: function render() {
      var _this$props2 = this.props,
          width = _this$props2.width,
          color = _this$props2.color,
          backgroundColor = _this$props2.backgroundColor;
      return _react["default"].createElement("svg", {
        width: width,
        height: width,
        viewBox: "0 0 24 24"
      }, _react["default"].createElement("defs", null, _react["default"].createElement("path", {
        id: "selected-a",
        d: "M21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,\n            12 C2.18181818,17.4224321 6.57756791,21.8181818 12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 Z M0,\n            12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 Z M12,\n            17.4545455 C15.0124623,17.4545455 17.4545455,15.0124623 17.4545455,12 C17.4545455,8.98753773 15.0124623,6.54545455 12,6.54545455 C8.98753773,\n            6.54545455 6.54545455,8.98753773 6.54545455,12 C6.54545455,15.0124623 8.98753773,17.4545455 12,17.4545455 Z"
      })), _react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        stroke: "black",
        strokeWidth: "0",
        fill: backgroundColor
      }), _react["default"].createElement("use", {
        fill: color,
        xlinkHref: "#selected-a"
      })));
    }
  }]);
  return Selected;
}(_react.PureComponent);

exports.Selected = Selected;
Selected.propTypes = {
  width: _propTypes["default"].string,
  color: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string
};
Selected.defaultProps = {
  width: '16px',
  color: _colors.teal.base,
  backgroundColor: 'none'
};